const currencyFormatterChf = new Intl.NumberFormat('de-CH', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  style: 'currency',
  currency: 'CHF',
});

export const getFormattedChfCurrency = (amount: number | string | null | undefined, noCurrencyLabel?: boolean) => {
  if (amount === null || amount === undefined || amount === '') return '';
  const numericAmount = Number(amount);
  if (isNaN(numericAmount)) return '';
  const formattedAmount = currencyFormatterChf.format(numericAmount).replace('.00', '.–');
  if (noCurrencyLabel) {
    return formattedAmount.replace('CHF', '');
  }
  return formattedAmount;
};
